export default __webpack_public_path__ + "static/media/coffeescript.51d09441.svg";